import React, { useContext, useEffect, useState } from "react";
import "./Blog.css";

import Blog_card from "./blog_card/Blog_card";
import { useDispatch, useSelector } from "react-redux";
import { getblog } from "../features/blog/Slice";
import Common_heading from "../common_components/common_heading/Common_heading";
import { GetAllDataOfInternship } from "../features/internship/Slice";
import { Context } from "../../utils/context";

function Blog() {
  const dispatch = useDispatch();

  const { language } = useContext(Context);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Blog", link: "", isActive: true },
  ];

  const allData = useSelector((state) => state?.blog?.blog?.blog || []);

  useEffect(() => {
    if (language) {
      dispatch(getblog({ language }));
    }
  }, [dispatch, language]);

  return (
    <section className="Blog">
      <div className="container">
        <Common_heading headingText="Our Blogs" />

        {/* <Breadcrumb_comp breadcrumbs={breadcrumbs} /> */}
        <div className="blog_card_holder">
          <div className="row">
            {allData.length > 0 ? (
              allData.map((blog, index) => (
                <div
                  className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
                  key={index}
                >
                  <Blog_card
                    baseLink={`/blog-inner/${blog.id}`}
                    blogData={blog}
                  />
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No blogs available yet</h3>
              </div>
            )}
          </div>

          {/* Pagination UI */}
          {/* <div className="pagination pagination_holder mt-4 d-flex justify-content-center align-items-center gap-2">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lsaquo;
            </button>

         
            {[currentPage].map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={page === currentPage ? "active" : ""}
              >
                {page}
              </button>
            ))}

            {totalPages > 3 && (
              <>
                <span>...</span>

                <button
                  onClick={() => handlePageChange(totalPages)}
                  className={currentPage === totalPages ? "active" : ""}
                >
                  {totalPages}
                </button>
              </>
            )}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &rsaquo;
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Blog;
